import _defineProperty from "/Users/n8/Development/NFT My Monstera/code/.build/websites/moodymonsteras.com/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/Users/n8/Development/NFT My Monstera/code/.build/websites/moodymonsteras.com/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
export function chainStateReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;

  var _a, _b, _c;

  var current = (_a = state[action.chainId]) === null || _a === void 0 ? void 0 : _a.blockNumber;

  if (!current || action.blockNumber >= current) {
    if (action.type === 'FETCH_SUCCESS') {
      var newState = action.state;

      if (action.blockNumber === current) {
        // merge with existing state to prevent requests coming out of order
        // from overwriting the data
        var oldState = (_c = (_b = state[action.chainId]) === null || _b === void 0 ? void 0 : _b.state) !== null && _c !== void 0 ? _c : {};

        for (var _i = 0, _Object$entries = Object.entries(oldState); _i < _Object$entries.length; _i++) {
          var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
              address = _Object$entries$_i[0],
              entries = _Object$entries$_i[1];

          newState = Object.assign(Object.assign({}, newState), _defineProperty({}, address, Object.assign(Object.assign({}, entries), newState[address])));
        }
      }

      return Object.assign(Object.assign({}, state), _defineProperty({}, action.chainId, {
        blockNumber: action.blockNumber,
        state: newState
      }));
    } else if (action.type === 'FETCH_ERROR') {
      return Object.assign(Object.assign({}, state), _defineProperty({}, action.chainId, Object.assign(Object.assign({}, state[action.chainId]), {
        blockNumber: action.blockNumber,
        error: action.error
      })));
    }
  }

  return state;
}